<h1 class="hero-title">{{ title() }}</h1>
<div class="hero-row">
  <div
    class="dashboard-banner-image"
    [class.banner-standard]="layout() === 'standard'"
    [class.banner-standard-centered]="layout() === 'standard-centered'"
    [class.banner-referral]="layout() === 'referral'"
    [style.aspect-ratio]="aspectRatio()"
    [style.max-width]="
      layout() === 'standard-centered' ? centeredMaxWidth : null
    "
  >
    @if (banner(); as banner) {
      @if (!banner.imageUrl) {
        <!-- Only the admin preview passes a banner with no image yet. -->
        <div class="banner-placeholder">Choose an image to preview it here</div>
      } @else if (isExternalUrl(banner.clickRoute)) {
        <!-- EXT-6166: a full URL is a real link; a path stays in-app. -->
        <a [href]="banner.clickRoute" target="_blank" rel="noopener">
          <img
            [src]="banner.imageUrl"
            [alt]="banner.altText"
            class="dashboard-cms-image"
          />
        </a>
      } @else {
        <a [routerLink]="banner.clickRoute">
          <img
            [src]="banner.imageUrl"
            [alt]="banner.altText"
            class="dashboard-cms-image"
          />
        </a>
      }
    }
  </div>

  @if (showSideColumn()) {
    <div class="dashboard-side-column">
      <a class="resource-center" routerLink="/resource-center">
        <img
          src="assets/dealer-dashboard/resource-center.png"
          alt="Resource Center: Download Images & Videos, Get Started"
          width="280"
          height="70"
        />
      </a>
      <div class="side-buttons">
        <div class="pill-row pill-row-balance">
          <button
            type="button"
            class="pill pill-navy pill-label-sized"
            (click)="onBalance()"
          >
            <span class="material-symbols-outlined" aria-hidden="true"
              >visibility</span
            >
            View Your Balance
          </button>
        </div>
        <a class="pill pill-blue pill-half" routerLink="/training-videos">
          <span class="material-symbols-outlined" aria-hidden="true"
            >play_circle</span
          >
          Training Videos
        </a>
        <a class="pill pill-blue pill-half" routerLink="/reports/low-inventory">
          <span class="material-symbols-outlined" aria-hidden="true"
            >trending_down</span
          >
          Low Inventory
        </a>
        @if (ecomStatus() === "H") {
          <div class="pill-row pill-row-referral">
            <a
              class="pill pill-plum pill-label-sized"
              routerLink="/referral-dashboard"
              >Referral Dashboard</a
            >
          </div>
        }
        @if (ecomStatus() === "I") {
          <div class="pill-row pill-row-referral">
            <a
              class="pill pill-plum pill-label-sized"
              routerLink="/referral-program-information"
              >Become a Referral Dealer</a
            >
          </div>
        }
      </div>
    </div>
  }
</div>
